<template>
  <div class="index fcc" id="app1">
    <img class="img2" src="/static/imgs/img1.png" />
    <img class="img2s" src="/static/imgs/img1.png" />
    <div class="tit">{{ name }}</div>
    <div class="code2 fcc">
      <img
        class="img1s"
        :src="
          'https://web.justhouse.cn/BigInterface/index/loginCode&web_code=' +
          web_code
        "
      />
    </div>
    <div class="ps2">请由活动管理员扫码登录</div>
    <div :class="shi == false ? 'shi fcc dis_none' : 'shi fcc'">
      <div style="margin-top: 80px">二维码已失效</div>
      <div class="shua" @click="shua">点击刷新</div>
    </div>
    <div class="bot">
      <img class="img3" src="/static/imgs/img2.png" />
    </div>
    <div class="frcs gud">
      此服务由小程序「微购会」提供技术支持
      <div class="frc">
        <!-- <img
          class="img4"
          v-if="rightShow == 1"
          @click="hideRight"
          src="/static/imgs/img3.png"
        />
        <img
          class="img4"
          v-else
          @click="hideRight"
          src="/static/imgs/img4.png"
        />
        <div class="set1 cc" v-if="rightShow == 0" @click="hideRight">
          展开菜单
        </div>
        <div class="frc" v-if="rightShow == 1">
          <el-button
            class="set1 cc"
            style="
              background: none;
              color: #fcc876;
              border: 1px solid #fcc876;
              font-size: 16px;
            "
            v-if="!fullscreen"
            @click="fullScreen()"
            >全屏显示</el-button
          >
          <el-button
            class="set1 cc"
            style="
              background: none;
              color: #fcc876;
              border: 1px solid #fcc876;
              font-size: 16px;
            "
            v-else
            @click="exitFullscreen()"
            >退出全屏</el-button
          >
        </div> -->
      </div>
    </div>
    <!-- 音频播放 -->
    <audio ref="audio" controls style="opacity: 0">
      <source src="/static/audio/背景音乐.mp3" type="audio/mp3" />
    </audio>
    <!-- 音频播放 结束-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      timer: null,
      timer2: null,
      session_3rd: "",
      web_code: "",
      shi: false,
      name: "",
      fullscreen: false,
      isplaying: false,
      rightShow: 1,
    };
  },
  mounted: {},
  methods: {
    // 隐藏右下角功能按钮
    hideRight() {
      if (this.rightShow == 0) {
        this.rightShow = 1;
      } else {
        this.rightShow = 0;
      }
    },
    // 背景音乐
    openAudio() {
      if (this.isplaying == false) {
        this.isplaying = true;
        this.$refs.audio.play();
      } else {
        this.isplaying = false;
        this.$refs.audio.pause();
      }
    },
    //全屏
    fullScreen() {
      var full = document.getElementById("app1");
      this.fullscreenFn(full);
      this.fullscreen = true;
    },
    exitFullscreen() {
      // 退出全屏
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      this.fullscreen = false;
    },
    fullscreenFn(element) {
      // 全屏
      if (element.requestFullscreen) element.requestFullscreen();
      else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
      else if (element.webkitRequestFullscreen)
        element.webkitRequestFullscreen();
      else if (element.msRequestFullscreen) element.msRequestFullscreen();
    },

    // 获取web_code
    obtainType() {
      var param = {
        code: this.$route.query.code,
      };
      this.$get(this.$axios.defaults.orURL + "/index/getWebCode", param).then(
        (res) => {
          this.$refs.audio.play();
          if (res.code == 1) {
            console.log(res);
            this.web_code = res.data.web_code;

            // 成功后三秒调用一次身份标识接口
            this.timer = setInterval(() => {
              this.getSession3rd();
            }, 3000);

            // 5分钟后获取身份标识截停
            this.timer2 = setInterval(() => {
              this.shi = true;
              clearInterval(this.timer);
              this.timer = null;
            }, 300000); //300000
          }
        }
      );
    },
    getName() {
      var param = {
        code: this.$route.query.code,
      };
      this.$get(this.$axios.defaults.orURL + "/index/getName", param).then(
        (res) => {
          if (res.code == 1) {
            this.name = res.data.name;
          }
        }
      );
    },
    shua() {
      this.shi = false;
      this.obtainType();
    },
    ban() {
      window.location.href = "https://web.justhouse.cn/";
    },
    getSession3rd() {
      var param = {
        web_code: this.web_code,
      };
      this.$get(
        this.$axios.defaults.orURL + "/Index/getSession3rd",
        param
      ).then((res) => {
        console.log(2222);
        console.log(res);
        if (res.code == 1) {
          console.log(res.data.session_3rd);
          console.log("成功！！！");
          localStorage.setItem("session_3rd", res.data.session_3rd);
          // localStorage.getItem('session_3rd') = res.data.session_3rd;
          this.$router.push("/raffle?code=" + this.$route.query.code);
        }
      });
    },
  },
  created() {
    this.obtainType();
    this.getName();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.timer2);
    this.timer2 = null;
  },
};
</script>
<style>
body {
  margin: 0;
  padding: 0;
}

.set1 {
  width: 90px;
  height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  color: #fcc876;
  border: 1px solid #fcc876;
}

.index .dis_none {
  display: none;
}

.index .gud {
  width: 90%;
  position: fixed;
  bottom: 40px;
  left: 0;
  color: #feb9b4;
  margin-left: 5%;
}

.index {
  width: 100%;
  min-height: 100vh;
  color: #fff;
  margin: 0;
  padding-top: 160px;
  box-sizing: border-box;
  background-image: linear-gradient(to bottom, #d93326, #ff5f52);
}

.index .img2 {
  width: 80px;
  height: 80px;
  position: fixed;
  top: 100px;
  left: 80px;
}

.index .img4 {
  width: 16px;
  height: 18px;
  cursor: pointer;
}

.index .img2s {
  width: 80px;
  height: 80px;
  position: fixed;
  bottom: 200px;
  right: 100px;
}

.index .img3 {
  width: 100%;
  height: 400px;
}

.frc {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fcc {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.frcs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.index .tit {
  font-size: 60px;
  color: #fdc976;
}

.index .code2 {
  width: 280px;
  height: 280px;
  border-radius: 10px;
  margin-top: 40px;
  background-color: #fff;
}

.index .shi {
  width: 200px;
  height: 200px;
  border-radius: 10px;
  margin-top: -315px;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(10, 5, 5, 0.8);
}

.index .shua {
  color: rgba(87, 107, 149, 1);
  margin-top: 10px;
}

.index .img1s {
  width: 250px;
  height: 250px;
  margin: 17px 0 20px;
}

.index .ps2 {
  font-size: 20px;
  margin-top: 25px;
  color: #fff;
}

.index .bot {
  position: absolute;
  bottom: 0px;
  width: 100%;
  font-size: 20px;
  margin-top: 50px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue